import {
  faCalendarAlt,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "react-bootstrap";

export default function Filtro({
  onClear,
  children,
}: {
  onClear: () => void;
  children: React.ReactNode;
}) {
  return (
    <div className="me-3 d-flex align-items-center">
      <Button className="d-flex align-items-center" onClick={onClear}>
        <FontAwesomeIcon icon={faCalendarAlt} className="me-2 text-white" />
        <span className="text-white">{children}</span>

        <FontAwesomeIcon
          icon={faTimesCircle}
          className="p-0 ms-2 text-white d-flex align-items-center justify-content-center"
        />
      </Button>
    </div>
  );
}
